import {forwardRef, ReactElement} from 'react';
import Konva from 'konva';
import {Image, Layer} from 'react-konva';

type Props = {
  image: HTMLImageElement;
  stageDimensions: {
    width: number;
    height: number;
  };
};

export default forwardRef<Konva.Image, Props>(function Media(
  {image, stageDimensions},
  ref
): ReactElement {
  return (
    <Layer>
      <Image
        image={image}
        width={stageDimensions.width}
        height={stageDimensions.height}
        ref={ref}
      />
    </Layer>
  );
});
